const testimonials = [
  {
    name: "Marcus T.",
    location: "Kenner, LA",
    rating: 5,
    text: "I work for an airline at MSY and got called for an international deadhead assignment to Frankfurt with 36 hours notice. My passport had expired 8 months earlier. I called Fast Passport Center at 7 AM, had my documents in an overnight envelope by 10 AM, and had my new passport in my hands in 5 business days. Saved my assignment and my reputation. These guys move as fast as we do at the airport.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Sandra & Ray B.",
    location: "River Ridge, LA",
    rating: 5,
    text: "We booked a Caribbean cruise out of New Orleans on a last-minute deal — incredible price, couldn't pass it up. Three days later we realized Ray's passport had expired two years ago. We were six weeks from sailing. Fast Passport Center walked us through everything, we shipped documents from Kenner the next morning, and his passport arrived 8 days later. We sailed. Amazing service.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Derek W.",
    location: "Kenner, LA — Offshore Energy",
    rating: 5,
    text: "I'm a subsea engineer based out of the Kenner area and rotate between Gulf and West Africa platforms. My passport expired during a long domestic stretch and I got international rotation papers with 12 days notice for Angola. Fast Passport Center processed my emergency renewal in 4 business days. Did not miss my rotation. They understand oilfield timelines — which is more than I can say for the post office.",
    service: "Emergency Renewal — Offshore Rotation",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function KennerTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Kenner &amp; Jefferson Parish Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real stories from Kenner airport workers, River Ridge families, and offshore energy professionals who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}